import { render } from "./ActiveChat.vue?vue&type=template&id=10ab8e7a&scoped=true"
import script from "./ActiveChat.vue?vue&type=script&lang=js"
export * from "./ActiveChat.vue?vue&type=script&lang=js"

import "./ActiveChat.vue?vue&type=style&index=0&id=10ab8e7a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10ab8e7a"

export default script